module.exports = __webpack_public_path__ + "img/21.ef96f44d.jpg";